{
  "ankara": { "x": 762, "y": 346 },
  "elazig": { "x": 985, "y": 393 },
  "erzurum": { "x": 1140.8, "y": 295.4 },
  "trabzon": { "x": 1014.8, "y": 266.1 },
  "samsun": { "x": 916.3, "y": 236.3 },
  "kastamonu": { "x": 685, "y": 217.8 },
  "mosul": { "x": 1254.2, "y": 518.7 },
  "baghdad": { "x": 1267.1, "y": 670.2 },
  "adana": { "x": 782.2, "y": 540.8 },
  "hatay": { "x": 887.2, "y": 545 },
  "maras": { "x": 906.9, "y": 477.8 },
  "isparta": { "x": 566.4, "y": 476.9 },
  "rhodes": { "x": 424.2, "y": 541.8 },
  "aydin": { "x": 450, "y": 482.2 },
  "usak": { "x": 520, "y": 456.6 },
  "balikesir": { "x": 446.7, "y": 294.3 },
  "eskisehir": { "x": 518.2, "y": 307.8 },
  "istanbul": { "x": 509.8, "y": 232.4 },
  "edirne": { "x": 406.5, "y": 188.7 },
  "van": { "x": 1261.5, "y": 387 },
  "western-thrace": { "x": 306.1, "y": 251.3 },
  "plovdiv": { "x": 291.3, "y": 179.7 },
  "burgas": { "x": 329.3, "y": 136.2 },
  "sofia": { "x": 216.7, "y": 67.5 },
  "varna": { "x": 404.9, "y": 38.9 },
  "gelibolu": { "x": 345.1, "y": 278.1 },
  "canakkale": { "x": 348.1, "y": 316 },
  "lesbos": { "x": 370.8, "y": 359 },
  "izmir": { "x": 387.9, "y": 415.1 },
  "kozani": { "x": 114.2, "y": 303.4 },
  "salonica": { "x": 209.9, "y": 258 },
  "kars": { "x": 1256, "y": 257 },
  "gyumri": { "x": 1293.6, "y": 261.6 },
  "yerevan": { "x": 1324.3, "y": 274.4 },
  "igdir": { "x": 1305.4, "y": 323.6 },
  "vanadzor": { "x": 1355.7, "y": 285.4 },
  "sevan": { "x": 1380.4, "y": 367.7 },
  "kutahya": { "x": 613.2, "y": 434.2 },
  "sakarya": { "x": 596.7, "y": 242.5 },
  "diyarbakir": { "x": 1082.2, "y": 431 }
}
